import { BlockModel } from '../../../../Common/PageBuilder/models/block.model';
import { ChartDisplayElementModel } from '../../../../Common/Reports/models/chart-display-element.model';
import { ReportBlockTypeEnum } from '../../../../Common/Reports/enums/report-block-type.enum';
import { ReportsDataMappingKeysEnum } from '../../../../Common/Reports/models/reports-block-mapping-configuration.model';
import { ExternalChartMetricsEnum } from '../../../../Common/Reports/enums/external-chart-metrics.enum';
import { GoogleAnalyticsReportTypesEnum } from '../../../../api/externalData/enums/google-analytics-report-types.enum';
import { ChartMetricsEnum } from '../../../../Common/Reports/enums/chart-metrics.enum';
import { getTimeScale } from '../../../../Common/Forms/helpers/time.helper';


export function sharedReportDataFromTwoPointOhToTwoPointOne(block: BlockModel, chartData: any): BlockModel {
    let data;
    let newDataPoints;
    let referralTypes;
    let referralTypesSet: Set<GoogleAnalyticsReportTypesEnum>;
    let referralTypesEnum;
    const displayElement = block.displayElement as ChartDisplayElementModel;

    switch (block.type.key) {
        case ReportBlockTypeEnum.TOP_SOCIAL_REFERRERS:
            data = displayElement.series[0].dataProvider.getValue();
            data.forEach(dataPoint => {
                dataPoint.label = dataPoint.label;
                dataPoint.mappingKeys = dataPoint.mappingKeys ||
                    {
                        [ReportsDataMappingKeysEnum.REFERRER]: dataPoint.label
                    };
                dataPoint.value = dataPoint.value || dataPoint.xValue;
            });
            displayElement.series[0].dataProvider.next(data);
            break;
        case ReportBlockTypeEnum.TOP_REFERRAL_SOURCES:
            let stacked = false;
            data = displayElement.series[0].dataProvider.getValue();
            data.forEach(dataPoint => {
                if (!(displayElement.metric === ExternalChartMetricsEnum.sessions || displayElement.metric === ExternalChartMetricsEnum.users)) {
                    stacked = true;
                }
                dataPoint.label = dataPoint.label || dataPoint['source'];
                dataPoint.mappingKeys = dataPoint.mappingKeys ||
                    {
                        [ReportsDataMappingKeysEnum.SOURCE]: dataPoint['source'],
                        [ReportsDataMappingKeysEnum.GA_METRIC]: dataPoint.id
                    };
                dataPoint.value = dataPoint.value || dataPoint.yValue;
            });
            if (stacked) {
                data = data.filter(dataPoint => !(dataPoint.mappingKeys[ReportsDataMappingKeysEnum.GA_METRIC] === ExternalChartMetricsEnum.sessions
                    || dataPoint.mappingKeys[ReportsDataMappingKeysEnum.GA_METRIC] === ExternalChartMetricsEnum.users));
            }
            displayElement.series[0].dataProvider.next(data);
            break;
        case ReportBlockTypeEnum.REFERRAL_TREND:
            data = displayElement.series[0].dataProvider.getValue();
            let dataPoints = data;
            if (data.length > 0) {
                dataPoints = [];
                const fromDate = data[0].from - (data[0].from % 86400000);
                const toDate = data[0].to - (data[0].to % 86400000);
                const timeScale = getTimeScale(fromDate, toDate);
                referralTypes = displayElement.referralTypes;
                referralTypesSet = new Set<GoogleAnalyticsReportTypesEnum>();
                referralTypesEnum = Object.values(GoogleAnalyticsReportTypesEnum);
                if (!data[0].mappingKeys) {
                    data.forEach(x => {
                        Object.keys(x).forEach((k: GoogleAnalyticsReportTypesEnum) => {
                            if (referralTypesEnum.includes(k)) {
                                referralTypesSet.add(k);
                            }
                        });
                    });
                    const referralTypesOrder = [
                        GoogleAnalyticsReportTypesEnum.TOTAL_REFERRALS,
                        GoogleAnalyticsReportTypesEnum.WEB_REFERRALS,
                        GoogleAnalyticsReportTypesEnum.SOCIAL_REFERRALS,
                        GoogleAnalyticsReportTypesEnum.EMAIL_REFERRALS
                    ];
                    referralTypes = Array.from(referralTypesSet).sort((a, b) => {
                        return referralTypesOrder.indexOf(a) - referralTypesOrder.indexOf(b);
                    });
                }
                displayElement.referralTypes = displayElement.referralTypes || referralTypes;
                data.forEach(dataPoint => {
                    referralTypes.forEach(type => {
                        const point = {
                            mappingKeys: dataPoint.mappingKeys ||
                                {
                                    [ReportsDataMappingKeysEnum.DATE]: dataPoint.rawDateFacetFrom,
                                    [ReportsDataMappingKeysEnum.REFERRER_TYPE]: type
                                },
                            value: dataPoint.value || dataPoint[type],
                            mentionCount: dataPoint.value || dataPoint[type],
                            rawStartDate: data.rawStartDate || dataPoint.rawDateFacetFrom,
                            rawEndDate: data.rawEndDate || dataPoint.rawDateFacetTo,
                            timeScale: timeScale
                        };
                        dataPoints.push(point);
                    });
                });
            }
            displayElement.series[0].dataProvider.next(dataPoints);
            break;
        case ReportBlockTypeEnum.COVERAGE_IMPACT_TREND:
            const newMentionDataPoints = [];
            const mentionData = displayElement.series[0].dataProvider.getValue();
            mentionData.forEach(dataPoint => {
                newMentionDataPoints.push({
                    label: dataPoint.label,
                    mappingKeys: dataPoint.mappingKeys || {
                        date: dataPoint['xValue'],
                        [ReportsDataMappingKeysEnum.COVERAGE_IMPACT_TREND_METRIC]: ChartMetricsEnum.volumeOfMentions
                    },
                    value: dataPoint.value || dataPoint['yValue'],
                    valueLabel: dataPoint.valueLabel || displayElement.series[0].label,
                    mentionCount: dataPoint.mentionCount,
                    rawStartDate: dataPoint.rawStartDate || dataPoint.rawDateFacetFrom,
                    rawEndDate: dataPoint.rawEndDate || dataPoint.rawDateFacetTo
                });
            });
            displayElement.series[0].dataProvider.next(newMentionDataPoints);

            const newExternalDataPoints = [];
            const externalData = displayElement.series[1].dataProvider.getValue();
            referralTypes = displayElement.referralTypes;
            referralTypesSet = new Set<GoogleAnalyticsReportTypesEnum>();
            referralTypesEnum = Object.values(GoogleAnalyticsReportTypesEnum);
            if (!externalData[0]?.mappingKeys) {
                externalData.forEach(x => {
                    Object.keys(x).forEach((k: GoogleAnalyticsReportTypesEnum) => {
                        if (referralTypesEnum.includes(k)) {
                            referralTypesSet.add(k);
                        }
                    });
                });
                const referralTypesOrder = [
                    GoogleAnalyticsReportTypesEnum.TOTAL_PAGEVIEWS,
                    GoogleAnalyticsReportTypesEnum.SESSIONS,
                    GoogleAnalyticsReportTypesEnum.USERS
                ];
                referralTypes = Array.from(referralTypesSet).sort((a, b) => {
                    return referralTypesOrder.indexOf(a) - referralTypesOrder.indexOf(b);
                });
                displayElement.referralTypes = referralTypes;
                displayElement.series[1].referralTypes = referralTypes;
            }
            externalData.forEach((dataPoint, index) => {
                referralTypes.forEach(referralType => {
                    newExternalDataPoints.push({
                        label: dataPoint.label ,
                        mappingKeys: dataPoint.mappingKeys || {
                            // hack: use the same timestamp as the one in mention data at the same position
                            // instead of converting timezones based on user preferences
                            [ReportsDataMappingKeysEnum.DATE]: newMentionDataPoints[index].mappingKeys[ReportsDataMappingKeysEnum.DATE],
                            [ReportsDataMappingKeysEnum.COVERAGE_IMPACT_TREND_METRIC]: referralType
                        },
                        value: dataPoint.value || dataPoint[referralType],
                        valueLabel: dataPoint.valueLabel || displayElement.series[0].label,
                        mentionCount: dataPoint.mentionCount || dataPoint[referralType],
                        rawStartDate: dataPoint.rawStartDate || dataPoint.rawDateFacetFrom,
                        rawEndDate: dataPoint.rawEndDate || dataPoint.rawDateFacetTo
                    });
                });
            });
            displayElement.series[1].dataProvider.next(newExternalDataPoints);
            break;
    }

    block['version'] = '2.1';
    return block;
}

